import Route from '@ember/routing/route';

export default class TermsPolicyDari extends Route {
  // normal class body definition here
}
